import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BdUserCookieService } from './cookie.service';
import { of } from 'rxjs';
import { USER_COOKIE_CCM19_API_KEY, USER_COOKIE_CCM19_DOMAIN_ID } from '../ccm19.config';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [BdUserCookieService],
})
export class BdUserCookieModule {
  public static forRoot(): ModuleWithProviders<BdUserCookieModule> {
    return {
      ngModule: BdUserCookieModule,
      providers: [
        {
          provide: USER_COOKIE_CCM19_API_KEY,
          useValue: '5894089525888ce5c262843cf003c6e18a6655024bc18588',
        },
        provideAppInitializer(() => {
        const initializerFn = ((
            userCookieService: BdUserCookieService,
            userCookieCCM10DomainId: string,
          ) => {
            userCookieService.init(userCookieCCM10DomainId);
            return () => of();
          })(inject(BdUserCookieService), inject(USER_COOKIE_CCM19_DOMAIN_ID));
        return initializerFn();
      }),
      ],
    };
  }
}
